import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Menu from "ui/Menu";
import useClickOutside from "hooks/useClickOutside";
import { centerNode } from "lib/visual";

/**
 * Выпадающий список  для добавления тега. Вынесен чтобы не было проблем с кликом вне его
 * В таком случае обработчик клика вне не сработает в момент клика по "открывшке" этого списка
 *
 * @param {object[]} availableTags - список тегов которые можно выбрать дополнительно
 * @param {func} onSelectAvailableItem - обработчик выбора нового тега
 * @param {func} handleClickOutside - обработчик клика на удалении тега
 * @param {number} recalculateFix - костыль, который показывает число тегов. Нужен для пересчета сентрирования
 */
const TagListDropdown = ({
    availableTags,
    onSelectAvailableItem,
    handleClickOutside,
    recalculateFix,
}) => {
    const $collapse = useRef(null);
    useClickOutside($collapse, handleClickOutside);

    useEffect(() => {
        centerNode($collapse.current);
    }, [recalculateFix]);

    return (
        <div className="tag-list__add-list" ref={$collapse}>
            <Menu
                classNames={{
                    item: ["menu__item_clickable"],
                    container: ["menu_small"],
                }}
                items={availableTags.map(({ text, value, ...other }) => ({
                    ...other,
                    content: text,
                    value,
                    onClick: onSelectAvailableItem,
                }))}
            />
        </div>
    );
};

TagListDropdown.propTypes = {
    availableTags: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.any.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
        })
    ),
    onSelectAvailableItem: PropTypes.func,
    handleClickOutside: PropTypes.func,
    recalculateFix: PropTypes.number,
};

export default TagListDropdown;
